import React, {useEffect, useState} from 'react'
import PaperComponent from "../../../components/MuiDraggableDialog";
import {Dialog, DialogContent, DialogContentText, DialogTitle, Paper} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "../../../components/MDBox";
import {noop} from "lodash";
import Grid from "@mui/material/Grid";
import {cargoOwnerInfo, cargoOwnerInfoReset, packInfo} from "../../../actions/inventory/inventoryAction";
import {useDispatch} from "react-redux";

import {Logout, onErrorAlert} from "../../../actions";
import {useNavigate} from "react-router-dom";
import LocalStorage from "../../../utils/LocalStorage";
import {useTranslation} from "react-i18next";
import OwnerCargoInformation from "./OwnerCargoInformation";
import AddressesInformation from "./AddressesInformation";
import OwnerCargoOperationDetail from "./OwnerCargoOperationDetail";
import OwnerCargoInfo from "./OwnerCargoInformation";
import OperationInfo from "../../inbounds/OperationInfo";
import UserCarrierEdit from "../../profile/userInformation/UserCarrierEdit";
import OwnerDiscountInformation from "./OwnerCargoInformation/OwnerDiscountInformation";
import MDTypography from "../../../components/MDTypography";
import FramerFade from "../../../components/Animation/Fade";
import PlatformSettings from "../../profile/components/PlatformSettings";
import Draggable from "react-draggable";
import {userWHMpCfgReset} from "../../../actions/userWHMp/userWHMpAction";
import PaymentTermEdit from "./OwnerCargoInformation/PaymentTermEdit";
import {cargoOwnerAddressList, cargoOwnerDiscountList} from "../../../actions/customer/customerAction";
import {v4 as uuidv4} from "uuid";
const OwnerCargoPreviewer = ({isOpen, setIsOpen, type = 'Preview', setType, data = {}}) => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch()
    const [ownerResp,setOwnerResp] = useState({})
    const [addressList,setAddressList] = useState([])
    const [discountList,setDiscountList] = useState([])
    const [addressData,setAddressData] = useState(null)
    const [discountData,setDiscountData] = useState({})
    const [loading, setLoading] = useState(true)
    const nav = useNavigate()
    const [openCarrierEdit,setOpenCarrierEdit] = useState(false)
    const [openStorageFeeTermEdit,setOpenStorageFeeTermEdit] = useState(false)
    const [list,setList] = useState([])
    const [total,setTotal] = useState(0)
    const onInfoSuccess = (detailData) => {
        setAddressList(detailData?.addresses)
        setOwnerResp(detailData?.ownerResp)
        setDiscountList(detailData?.ownerFeeDiscountInfos)
        setLoading(false)
    }

    useEffect(()=>{
        if(!isOpen){
            setOwnerResp({})
            setAddressList([])
            setDiscountData({})
            setAddressData({})
        }
    },[isOpen])

    const onError = (msg,code) => {
        dispatch(onErrorAlert(t(msg)))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onDiscountSuccess = (data) => {
        setList( data?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }))
        setTotal(data?.total)
        // setDiscountData(data)
    }

    const onAddressSuccess = (data) => {
        setAddressData(data)
    }

    useEffect(() => {

        if(isOpen){

            const axiosPost= async () => {
                let formData = {}
                formData.ownerId = data?.ocpOwnerId
                formData.userName = LocalStorage.getItem('username')
                formData.pageNum = 1
                formData.pageSize = 5
                setLoading(true)
                await dispatch(cargoOwnerDiscountList(formData,onDiscountSuccess,onError))
                await dispatch(cargoOwnerAddressList(formData,onAddressSuccess,onError))
                await dispatch(cargoOwnerInfo(formData, onInfoSuccess,onError))
            }
            axiosPost().then()
        }

    }, [isOpen])
    const getDiscountList = (pageSize,pageNum)=>{
        const axiosPost= async () => {
            let formData = {}
            formData.ownerId = data?.ocpOwnerId
            formData.userName = LocalStorage.getItem('username')
            formData.pageNum = pageNum
            formData.pageSize = pageSize
            setLoading(true)
            await dispatch(cargoOwnerDiscountList(formData,(data)=>{
                onDiscountSuccess(data)
                setLoading(false)
            },onError))
            // await dispatch(cargoOwnerAddressList(formData,onAddressSuccess,onError))
            // await dispatch(cargoOwnerInfo(formData, onInfoSuccess,onError))
        }
        axiosPost().then()
    }

    const handleCloseModal = () => {
        setLoading(true)
        setIsOpen(false)
        dispatch(cargoOwnerInfoReset())
    }

    return(<React.Fragment>
        <Dialog
            open={isOpen}
            onClose={handleCloseModal}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            scroll={'paper'}
            fullWidth={true}
            maxWidth={'xxl'}
            sx={{
                maxHeight: "100vh", // 限制 Dialog 最大高度
                overflow: "hidden", // 避免外部滚动条
                "& .MuiDialog-paper": {
                    maxHeight: "100vh", // 让 Dialog 内部 Paper 也受限
                    overflow: "hidden", // 避免不必要的外部滚动条
                },
            }}
        >

            <MDBox component="form" role="form" >
                <DialogTitle style={{cursor: 'move', display: 'flex', justifyContent: 'space-between',position: "sticky",
                    alignItems: "center",
                    top: 0,
                    zIndex: 1100,
                    boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
                }}
                            >
                    {type === 'Preview' &&<div> {`${t('CustomerPage.Cargo Owner ID')}: ${data?.ocpOwnerId}`}</div>}

                    <IconButton size="medium" onClick={handleCloseModal}>
                        <Icon>cancel</Icon>
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{
                    maxHeight: "80vh", // 限制最大高度，防止 Dialog 过长
                    overflowY: "auto", // 允许滚动
                }} >
                    <DialogContentText>
                        <MDBox mb={3} p={3}>
                            <Grid container spacing={3} flexDirection={'row'} alignItems={'start'}>
                                <Grid item xs={12}   mt={2}>
                                    <OwnerCargoInfo info={ownerResp}
                                                    openCarrierEdit={openCarrierEdit}
                                                    setOpenCarrierEdit={setOpenCarrierEdit}
                                                    setOpenStorageFeeTermEdit={setOpenStorageFeeTermEdit}
                                                    loading={loading}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container xs={12}  spacing={1} >
                                <Grid item xs={12} mt={5}>
                                    <Grid item xs={12}>
                                        <OwnerDiscountInformation info={ownerResp}
                                                                  loading={loading}
                                                                  setTotal={setTotal}
                                                                  total={total}
                                                                  setList={setList}
                                                                  list={list}
                                        /></Grid>
                                </Grid>
                            </Grid>
                            <Grid item container xs={12}  spacing={1} >
                                <Grid item xs={12} mt={5}>
                                    <Grid item xs={12}>
                                        <AddressesInformation
                                                              info={ownerResp}
                                                              addressData={addressData}
                                                              loading={loading}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} mt={5}>
                                <OwnerCargoOperationDetail info={ownerResp}
                                                           loading={loading}/>
                            </Grid>
                            {/*<Grid container spacing={3} flexDirection={'row'} alignItems={'flex-start'}>*/}
                            {/*    <Grid item xs={12} md={6} mt={4}>*/}
                            {/*        */}
                            {/*    </Grid>*/}
                            {/*    <Grid item container xs={12} md={6} spacing={2}>*/}
                            {/*        */}
                            {/*        <Grid item xs={12}><OwnerCargoOperationDetail info={ownerResp}/></Grid>*/}
                            {/*    </Grid>*/}
                            {/*</Grid>*/}
                        </MDBox>
                    </DialogContentText>
                </DialogContent>
            </MDBox>
        </Dialog>
        <UserCarrierEdit setOpen={setOpenCarrierEdit} open={openCarrierEdit} parent={"cargoOwner"} owner={data?.ocpOwnerId} />
        <PaymentTermEdit setOpen={setOpenStorageFeeTermEdit} open={openStorageFeeTermEdit} onInfoSuccess={onInfoSuccess}/>

    </React.Fragment>)
}

export default OwnerCargoPreviewer